module.exports = __webpack_public_path__ + "assets/img/img-smile.46a12af2.png";